import React from 'react';
import cn from 'classnames';
import { object, bool } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { UncontrolledTooltip } from 'reactstrap';
import Icon from '../Icon/Icon';

const propTypes = {
  source: object.isRequired,
  invert: bool.isRequired,
};
const defaultProps = {
  source: {},
  invert: false,
};

const renderHint = (id, prefix) => {
  return (
    <span className="offer-source-list-hint">
      {' '}
      <Icon id={`offer-source-list-hint-${prefix}-${id}`} type="info" />{' '}
      <UncontrolledTooltip placement="right" target={`offer-source-list-hint-${prefix}-${id}`}>
        <FormattedMessage id="sources.requre_agreement" defaultMessage="Agreement is required" />
      </UncontrolledTooltip>
    </span>
  );
};

const OfferSourceListItem = ({ source, invert, prefix }) => (
  <li className={cn('offer-source-list-item', { allowed: invert })}>
    <span className="offer-source-list-item-cross" />
    <span className="offer-source-list-item-title">
      {source.title} {invert && source.id === 7 && renderHint(source.id, prefix)}
    </span>
  </li>
);

OfferSourceListItem.propTypes = propTypes;
OfferSourceListItem.defaultProps = defaultProps;

export default OfferSourceListItem;
